module.exports = __webpack_public_path__ + "static/media/ResoluteAI-In-black-bg-social-media.52308f78.png";